/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  
document.addEventListener('DOMContentLoaded', function() {
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      // Sélectionner tous les éléments <p> avec la classe 'product-item__title'
      const productTitles = document.querySelectorAll('p.product-item__title');

      productTitles.forEach((element) => {
        // Créer un nouvel élément <h2>
        const newElement = document.createElement('h2');
        
        // Copier le contenu texte de l'élément <p> à l'élément <h2>
        newElement.innerHTML = element.innerHTML;

        // Copier toutes les classes de l'élément <p> à l'élément <h2>
        newElement.className = element.className;

        // Remplacer l'élément <p> par le nouvel élément <h2>
        element.parentNode.replaceChild(newElement, element);
      });
    });
  });

  // Observer les changements dans le body
  observer.observe(document.body, { childList: true, subtree: true });
});

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
